import { Injectable } from '@angular/core';
import { Color4, Mesh, PolygonMeshBuilder, TransformNode, Vector2, Vector3 } from 'babylonjs';
import * as MyEarcut from 'earcut';
import {
  CENTER_SPHERE_NAME,
  ELECTRIC_BLUE_COLOR,
  POLYGON_MESH_BUILDER_NAME,
  POLYGON_PICKER_SPHERE_NAME,
} from '@App/app/configs/babylon.config';
import { BabylonNodesService } from '../../babylon-nodes-service/babylon-nodes.service';
import { MaterialService } from '../../material-service/material.service';
import { SceneService } from '../../scene-service/scene.service';

@Injectable({
  providedIn: 'root',
})
export class PolygonMeshService {
  constructor(
    private babylonNodesService: BabylonNodesService,
    private materialService: MaterialService,
    private sceneService: SceneService,
  ) {}

  createSphere(position: Vector3, root: TransformNode, visible: boolean): Mesh {
    const sphere = this.babylonNodesService.createSphere(
      position.subtract(root.position),
      POLYGON_PICKER_SPHERE_NAME,
      this.materialService.electricBlueMaterial,
      { diameter: 0.05, segments: 16 },
    );

    sphere.renderingGroupId = 1;
    sphere.parent = root;
    sphere.isVisible = visible;
    return sphere;
  }

  initCenterSphere(position: Vector3): Mesh {
    const centerSphere = this.babylonNodesService.createSphere(
      position,
      CENTER_SPHERE_NAME,
      this.materialService.electricBlueMaterial,
      { diameter: 0.05, segments: 1 },
    );

    centerSphere.visibility = 0;
    centerSphere.position = position;
    return centerSphere;
  }

  createPolygonMesh(pointsMeshes: Mesh[], root: TransformNode): Mesh {
    /** Changed y and z axes because model is rotated 90 degrees in x axis */
    const spheresPositionsArr = pointsMeshes.map((e) => {
      return new Vector2(e.position.x, e.position.z);
    });
    const polygonMeshBuilder = new PolygonMeshBuilder(
      POLYGON_MESH_BUILDER_NAME,
      spheresPositionsArr,
      this.sceneService.scene,
      MyEarcut,
    );
    const polygonMesh = polygonMeshBuilder.build();

    polygonMesh.overrideMaterialSideOrientation = Mesh.DOUBLESIDE;
    polygonMesh.position.y = pointsMeshes[0].position.y + 0.2;
    polygonMesh.renderingGroupId = 2;
    polygonMesh.visibility = 0.45;
    polygonMesh.material = this.materialService.electricBlueMaterial;
    polygonMesh.enableEdgesRendering();
    polygonMesh.edgesColor = Color4.FromHexString(ELECTRIC_BLUE_COLOR + 'FF');
    polygonMesh.parent = root;

    return polygonMesh;
  }
}
